import React from 'react';
import _ from 'lodash';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';

import { Provenance as ProvenanceType } from 'common/types/view';
import { I18n } from 'common/i18n';
import { provenanceIcon } from 'common/components/AssetBrowser/lib/helpers/cellRendererHelpers';
import { FeatureFlags } from '@socrata/platform/feature-flags';

export interface ProvenanceProps {
  provenance: ProvenanceType | null;
  includeLabel?: boolean;
  type?: string;
}

export const Provenance: React.FC<ProvenanceProps> = ({ provenance, includeLabel = true, type }) => {
  // Hide if there is no provenance or if the provenanceIcon is either 'all', 'official2', or 'community'
  const icon = provenance ? provenanceIcon(provenance, true) : null;
  // Determine if we should hide the badge based on feature flag settings we use the old Socrata names here
  const shouldHide =
    provenance === null ||
    _.includes(['all', provenanceIcon(provenance, false)], FeatureFlags.value('disable_authority_badge'));

  if (shouldHide) {
    return null;
  }

  const t = (k: string, options: { [key: string]: any } = {}) =>
    I18n.t(k, { scope: 'shared.components.asset_badges', ...options });

  const tooltipText = () => {
    if (provenance == ProvenanceType.Official) {
      return t('official');
    } else if (provenance == ProvenanceType.Community) {
      return t('community_created');
    }
    return '';
  };

  return (
    <>
      <ForgeIcon className={`forge-tag-${provenance}`} name={icon} />
      <ForgeTooltip placement="top">{tooltipText()}</ForgeTooltip>
    </>
  );
};
